import { flow, orderBy } from 'lodash';
import filter from 'lodash/fp/filter';
import fromPairs from 'lodash/fp/fromPairs';
import map from 'lodash/fp/map';
import toPairs from 'lodash/fp/toPairs';

import RAW_BREAKPOINTS from './breakpoints.module.scss';

const BREAKPOINTS = flow([
  toPairs,
  filter(([key]) => !key.startsWith('__')),
  map(([key, value]) => [key.toUpperCase(), Number.parseInt(value)]),
  fromPairs,
])(RAW_BREAKPOINTS) as Record<Uppercase<keyof typeof RAW_BREAKPOINTS>, number>;

type Breakpoint = keyof typeof BREAKPOINTS;

const computeOrderedBreakponts = () => {
  const result: Array<[Breakpoint, number]> = [];

  let breakpoint: keyof typeof BREAKPOINTS;

  for (breakpoint in BREAKPOINTS) {
    result.push([breakpoint, BREAKPOINTS[breakpoint]]);
  }

  return orderBy(result, ([breakpoint, size]) => size);
}

const ORDERED_BREAKPOINTS = computeOrderedBreakponts();

const mapBreakpoints = <T>(func: (breakpoint: Breakpoint, size: number) => T) => {
  return ORDERED_BREAKPOINTS.map((args) => func(...args));
};

export { BREAKPOINTS, type Breakpoint, mapBreakpoints };
